<template>
    <div class="lesson-text-blocks">
        <draggable
            class="text-blocks"
            group="text-blocks"
            ghost-class="drag-ghost"
            :list="lessonIn.text_blocks"
            handle=".text-block-handle"
            @change="textBlockOrderChanged">
            <design-2021-lesson-manual-single-text-block-component
                @lesson-updated="lessonUpdated"
                @edit-slide="openEditSlideModal"
                @open-edit-modal="openEditModal"
                @add-slide="addSlide"
                @delete-text-block="deleteTextBlock"
                v-for="(textBlock) in lessonIn.text_blocks"
                :text-block-in="textBlock"
                :key="textBlock.id"
                :lesson-in="lessonIn"
                :editable="editable">
            </design-2021-lesson-manual-single-text-block-component>
        </draggable>

        <div
            class="new-text-block"
            v-if="editable">
            <b-button
                class="btn-add"
                variant="primary"
                @click="openCreateTextBlock">
                {{ $t('lesson.add_text_block') }}
            </b-button>
        </div>

        <design-2021-lesson-manual-create-text-block-modal
            ref="create-text-block-modal"
            :lesson-in="lessonIn"
            @lesson-updated="lessonUpdated">
        </design-2021-lesson-manual-create-text-block-modal>

        <design-2021-lesson-manual-edit-text-block-modal
            ref="edit-text-block-modal"
            :lesson-in="lessonIn"
            @lesson-updated="lessonUpdated">
        </design-2021-lesson-manual-edit-text-block-modal>

        <design-2021-lesson-manual-add-slide-modal
            ref="add-slide-modal"
            :lesson-in="lessonIn"
            @lesson-updated="lessonUpdated">
        </design-2021-lesson-manual-add-slide-modal>
        <design-2021-lesson-manual-edit-slide-modal
            ref="edit-slide-modal"
            :lesson-in="lessonIn"
            @lesson-updated="lessonUpdated">
        </design-2021-lesson-manual-edit-slide-modal>
    </div>
</template>

<script>
import draggable from 'vuedraggable';

export default {
    name: 'design-2021-lesson-manual-lesson-text-block-component',
    components: {
        draggable,
    },
    props: {
        lessonIn: {
            type: Object,
            required: true,
        },
        editable: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    methods: {
        addSlide(textBlock) {
            this.$refs['add-slide-modal'].show(textBlock);
        },
        openEditSlideModal(slide, textBlockId) {
            this.$refs['edit-slide-modal'].show(slide, textBlockId);
        },

        textBlockOrderChanged() {
            let array = [];
            let count = 0;

            for (const textBlock of this.lessonIn.text_blocks) {
                count++;
                array.push({
                    id: textBlock.id,
                    order: count,
                });
            }

            let data = {
                text_blocks: array,
            };

            this.axios.post(this.routes.updateTextBlockOrder(this.lessonIn.id), data).then(
                (response) => {}, //no action required
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        openCreateTextBlock() {
            this.$refs['create-text-block-modal'].show();
        },

        openEditModal(textBlock) {
            this.$refs['edit-text-block-modal'].show(textBlock);
        },
        lessonUpdated(newLesson) {
            this.$emit('lesson-updated', newLesson);
        },
        deleteTextBlock(textBlock) {
            this.alert
                .confirm(
                    this.$t('lesson.delete_text_block'),
                    this.$t('lesson.delete_text_block_description', { title: textBlock.title }),
                )
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();

                        this.axios.delete(this.routes.deleteLessonTextBlock(this.lessonIn.id, textBlock.id)).then(
                            (response) => {
                                this.$emit('lesson-updated', response.data);
                            },
                            (error) => {
                                return this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },
    },
};
</script>

<style scoped lang="scss">
</style>
